import comp from "./LinkModal";
export default comp;
